import React from "react";
import { Link } from "react-router-dom";

import { HOW_IT_WORK_OWNER, OWNER_GUIDE, OWNER_REGISTER } from "../../constant/routes";
import { ExplorerCar } from "../common/svg";

import bg from "../../static/images/landingpage/explorer/thue_xe_oto_tu_lai_di_du_lich_gia_re.png";

const Explorer = () => (
	<div className="explorer-section second">
		<div className="m-container">
			<div className="explorer-container">
				<div className="explorer-item">
					<div className="explorer-item__content">
						<div className="wrap-svg">
							<ExplorerCar />
						</div>
						<h2>
							Bạn muốn cho <br />
							thuê xe?
						</h2>
						<p>
							Hơn 5,000 chủ xe đang cho thuê hiệu quả trên&nbsp;Mioto
							<br />
							Đăng kí trở thành đối tác của chúng tôi ngay hôm nay để gia tăng thu nhập hàng&nbsp;tháng.
						</p>
						<div className="wrap-btn has-2-btn">
							<Link to={HOW_IT_WORK_OWNER} className="btn btn--m btn-default">
								Tìm hiểu ngay
							</Link>
							<Link to={OWNER_REGISTER} className="btn btn--m btn-blue">
								Đăng ký xe
							</Link>
						</div>
					</div>
					<div className="explorer-item__img">
						<img src={bg} alt="thueoto_tu_lai_di_du_lich_gia_re" />
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default Explorer;
